export const KEY_PREFIX = 'search_'
